import { useQuery } from 'react-query';
import { lovageApi } from 'src/axios';
import { Location } from 'src/types';

type OnboardingStatus = 'payment_information_required' | 'awaiting_first_installation' | 'complete';

export interface IntercomIdentityVerificationHashPlatform {
  ios: string;
  web: string;
  android: string;
}

export interface IntercomIdentityVerificationHash {
  platform: IntercomIdentityVerificationHashPlatform;
}

export interface CurrentUser {
  id: number;
  auth0_id: string;
  created_on: string; // date
  phone_number: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'admin';
  onboarding_status: OnboardingStatus;
  avatar_url: string;
  organization_name: string;
  stripe_customer_id: string;
  /**
   * A list of locations that are installed and accessible by the user.
   */
  locations: Location[];
  /**
   * Used to verify the user's identity with Intercom
   */
  intercom_identity_verification_hash: IntercomIdentityVerificationHash;
  is_marketing_customer: boolean;
}

export const fetchCurrentUser = () => {
  console.log('fetchCurrentUser');
  return lovageApi.get<CurrentUser>(`/dashboard/user`).then((res) => res.data);
};

export const queryKey = 'currentUser';

export default function useCurrentUser() {
  return useQuery([queryKey], fetchCurrentUser, {
    refetchOnWindowFocus: false,
  });
}
